import React, { useEffect, useState } from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import {ReactComponent as CloseIcon} from '../../../../../media/felsv/dark_close_icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { comprobanteRetencionCloseModalDocumentos } from '../../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'
import {ReactComponent as SearchIcon} from '../../../../../media/white_search_icon.svg'
import { getDateOperacionMes } from '../../../../../utils/stringDate'
import { DICCIONARIO } from '../../../../../constants/Diccionario'
import SearchSelect from '../../../../../components/Inputs/SearchSelect'
import { State } from '../../../../../reducers'
import { bindActionCreators } from 'redux'
import { actionComprobanteRetencionProducto } from '../../../../../actions/action-creators'
import TableDocumentosCRE from '../../Table/TableDocumentosCRE'
import { validarRegexNombresCliente, validarRegexNumericoInt } from '../../../../../utils/strings.utils'

const CREModalDocumentos = () => {
  const loader = useSelector((state: State) => state.comprobanteRetencion.modalDocumentos.loader)
  const documentos = useSelector((state: State) => state.comprobanteRetencion.modalDocumentos.documentos)
  const dispatch = useDispatch()
  return (
    <ModalBase Styles={{maxHeight: "85vh", minHeight: "55vh", minWidth: "80%"}}>
      <div className='modal-error-buttons-fixed-top' style={{padding:"1% 2.5% 0", backgroundColor:"white", zIndex:1000}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', }} >
          <h3 className='card-title l'>Búsqueda de Documentos Asociados</h3>
          <button style={{backgroundColor: '#FFFFFF'}}  onClick={() => dispatch(comprobanteRetencionCloseModalDocumentos())} ><CloseIcon width={35} height={35} /></button>
        </div>
      </div>
      <div className='modal-content' style={{width:"100%", padding:"1% 2.5%",}}>
        <div className='form-separator'></div>
        <CREFiltros />
        {loader && <CRELoaderDocumentos />}
        {!loader && <div style={{overflowX:"auto"}}><TableDocumentosCRE rows={documentos} sinAcciones={false} noAsociar={false} columnaNombres={true} /></div>}
      </div>
    </ModalBase>
  )
}

const CRELoaderDocumentos = () => {
  return (
    <div style={{display: 'flex', margin:"5%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px'}}>
        <div className='spinner'></div>
        Cargando documentos asociados...
    </div>
  )
}

const CREFiltros = () => {
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
  const {form, errorForm} = useSelector((state: State) => state.comprobanteRetencion.modalDocumentos)
  const [tiposDocs, setTiposDocs] = useState<Array<any>>([])
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionComprobanteRetencionProducto, dispatch)

  useEffect(() => {
    if(tipoDocumentosEmision.length > 0) setTiposDocs(tipoDocumentosEmision.filter((el) => el.codigodocumento === "01" || el.codigodocumento === "03"))
  }, [tipoDocumentosEmision]) 

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    const {name, value} = e.target;
    if(name === "numId" && !validarRegexNumericoInt(value)) return
    if(name === "nombre" && !validarRegexNombresCliente(value)) return
    acciones.comprobanteRetencionHandleChangeInput({[name]: value})
    acciones.creFormBusquedaValidacionesOnBlur(e)
  }

  const buscar = async(e: any) => {
    e.preventDefault();
    if(await acciones.creValidacionesOnSubmit()) return;
    await acciones.suscripcionVerificacionLimiteFacturas()
  }

  return (    
    <div className='w-form'>
    <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' onSubmit={buscar}>
      <div className='w-layout-hflex h-inputs'>
        <div className='filter-field'>
          <label htmlFor='numId' className='field-label m'>NIT emisor<span style={{color: 'red'}}>*</span></label>
          <input autoComplete='off' autoFocus type='text' className='m text-field w-input' maxLength={14} data-name='numId' placeholder="NIT Emisor" id='numId' name='numId' value={form.numId} onChange={handleChange} onBlur={acciones.creFormBusquedaValidacionesOnBlur}/>
           {errorForm.numId && <p className='alert s'>{errorForm.numId}</p>}
        </div>
        <div className='filter-field'>
          <label htmlFor='nombre' className='field-label m'>Nombre</label>
          <input autoComplete='off' type='text' className='m text-field w-input' maxLength={50} data-name='nombre' placeholder="Nombre" id='nombre' name='nombre' value={form.nombre} onChange={handleChange} onBlur={acciones.creFormBusquedaValidacionesOnBlur}/>
           {errorForm.nombre && <p className='alert s'>{errorForm.nombre}</p>}
        </div>
        <div className='filter-field'>
          <label htmlFor='inicio' className='field-label m'>Fecha Inicial<span style={{color: 'red'}}>*</span></label>
          <input autoComplete='off' type='date' className='m text-field w-input' maxLength={10} data-name='inicio' placeholder="Fecha Inicial" id='inicio' name='inicio'  min={getDateOperacionMes(-3)} max={getDateOperacionMes(0)} value={form.inicio} onChange={handleChange} onBlur={acciones.creFormBusquedaValidacionesOnBlur}/>
           {errorForm.inicio && <p className='alert s'>{errorForm.inicio}</p>}
        </div>
        <div className='filter-field'>
          <label htmlFor='fin' className='field-label m'>Fecha Final<span style={{color: 'red'}}>*</span></label>
          <input autoComplete='off' type='date' className='m text-field w-input' maxLength={10} data-name='fin' placeholder="Fecha Inicial" id='fin' name='fin'  min={getDateOperacionMes(-3)} max={getDateOperacionMes(0)} value={form.fin} onChange={handleChange} onBlur={acciones.creFormBusquedaValidacionesOnBlur} />
          {errorForm.fin && <p className='alert s'>{errorForm.fin}</p>}
        </div>
        <div className='filter-field'>
          <label htmlFor='tipo' className='field-label m'>{DICCIONARIO.TIPO_DTE}<span style={{color: 'red'}}>*</span></label>
          <SearchSelect defaultValue={null} placeholder={DICCIONARIO.TIPO_DTE} data={tiposDocs}  value={form.tipo}  name='tipo'  keyNameText='nombre'  keyNameValue='codigodocumento'  disabled={false}  placement="bottom"onChange={(value: any) => { handleChange({target: {value: value?.value, name: 'tipo'}})}}/>
          {errorForm.tipo && <p className='alert s'>{errorForm.tipo}</p>}
        </div>
        <div className='filter-field'>
          <label htmlFor='fin' className='field-label m' style={{visibility: "hidden"}}>Busqueda</label>
          <button type='submit' className='icon-button filter-search-btn'><SearchIcon width={20} height={20} /></button>
        </div>
      </div>
    </form>
  </div>
  )
}

export default CREModalDocumentos
